module.exports = {
  title: 'MNIST Neural Network Digit Recognition',
  author: 'Enzo Manuel Mangano',
  date: '2024-11-19',
  slug: 'mnist',
  tags: ['reanimated'],
};
